import { IScope } from 'angular'
import ngRedux from 'ng-redux'
import {
  selectIsSubmittedSaleEarly,
  selectSaleId,
  selectSaleNote,
  setSaleNote,
  setHasUpdateNoteOnConfirmation,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { RootState } from '../../../state/store'
import { SaleManager } from '../../../managers/sale-manager'

/**
 * Controller class for the sale note
 *
 * @class SaleNoteController
 */
export class SaleNoteController {
  public note: string = ''
  public placeholder?: string
  public saleID?: string
  public isSubmittedSaleEarly: boolean = false

  constructor(
    private readonly $ngRedux: ngRedux.INgRedux,
    $scope: IScope,
    private readonly saleManager: SaleManager
  ) {
    'ngInject'
    const disconnectRedux = $ngRedux.connect((state: RootState) => ({
      note: selectSaleNote(state),
      saleID: selectSaleId(state),
      isSubmittedSaleEarly: selectIsSubmittedSaleEarly(state),
    }))(this)
    $scope.$on('$destroy', disconnectRedux)
  }

  /**
   * Update the redux note field based on value in this.note
   */
  public updateNote() {
    this.$ngRedux.dispatch(setSaleNote(this.note))
    if (!this.saleID && this.isSubmittedSaleEarly) {
      this.$ngRedux.dispatch(setHasUpdateNoteOnConfirmation(true))
    }
    this.saleManager.saveSale()
  }
}
